import { Injectable } from "@angular/core";
import { ApiService } from "./api-service";
import { map } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class EducationalBackgroudService {
  constructor(private api: ApiService) {}

  // Add Educational Background
  addEducationBackground(body) {
    const url = `/EducationalBackground`;
    return this.api.post(url, body);
  }

  // Update Educational Background
  updateEducationBackground(id, body) {
    const url = `/EducationalBackground/${id}`;
    return this.api.put(url, body);
  }

  // Add Undergraduate
  addUndergraduateStudies(id, body) {
    const url = `/EducationalBackground/${id}/UndergraduateDegree`;
    return this.api.post(url, body);
  }

  // Update Undergraduate
  updateUndergraduate(id, body) {
    const url = `/EducationalBackground/UndergraduateDegree/${id}`;
    return this.api.put(url, body);
  }

  // Delete Undergraduate
  deleteUndergraduate(id) {
    const url = `/EducationalBackground/UndergraduateDegree/${id}`;
    return this.api.delete(url);
  }

  // Add Graduate
  addGraduateStudies(id, body) {
    const url = `/EducationalBackground/${id}/GraduateDegree`;
    return this.api.post(url, body);
  }

  // Update Graduate
  updateGraduateStudies(id, body){
    const url = `/EducationalBackground/GraduateDegree/${id}`;
    return this.api.put(url, body);
  }

  // Delete Graduate
  deleteGraduateStudies(id){
    const url = `/EducationalBackground/GraduateDegree/${id}`;
    return this.api.delete(url);
  }

  // Add Post Graduate
  addPostGraduateStudies(id, body) {
    const url = `/EducationalBackground/${id}/PostGraduateDegree`;
    return this.api.post(url, body);
  }

  // Update Post Graduate
  updatePostGraduateStudies(id, body){
    const url = `/EducationalBackground/PostgraduateDegree/${id}`;
    return this.api.put(url, body);
  }

  // Delete Post Graduate
  deletePostGraduateStudies(id){
    const url = `/EducationalBackground/PostgraduateDegree/${id}`;
    return this.api.delete(url);
  }

  // Undergraduate, Graduate, Post Graduate
  getEducationalBackgroundsMultipleItems(id) {
    const url = `/EducationalBackground/applicant/${id}`;
    return this.api.get(url).pipe(
      map((data: any) => {
        return data;
      })
    );
  }

  // get all educational details except multiple items
  getEducationalBackground(id) {
    const url = `/EducationalBackground/applicant/${id}`;
    return this.api.get(url).pipe(
      map((data: any) => {
        return data;
      })
    );
  }

}
